/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import { compose } from 'redux';
import cx from 'classnames';
import s from './Header.css';
import Link from '../Link';
import BasicNavigation from '../BasicNavigation';
import { getUserPriviliges } from '../../actions/authentication';
import logoUrl from './new_saocal_20.png';
import logoUrlSpirotech from './spirotech_new_logo.png';
import logoUrlSyr from './SYR_OCEANIC_Logo.png';

class BasicHeader extends React.Component {
  componentWillMount() {
    this.props.getUserPriviliges();
  }

  shouldComponentUpdate() {
    return true;
  }

  getLogo = producent => {
    switch (producent) {
      case 'husty':
        return (
          <Link className={cx(s.brand, s.Header_logo)} to="/">
            <img src={logoUrl} alt="Saocal" />
          </Link>
        );
      case 'syr':
        return (
          <Link className={cx(s.brand, s.Header_logo)} to="/">
            <img src={logoUrlSyr} alt="Syr" />
          </Link>
        );
      case 'oceanic':
        return (
          <Link className={cx(s.brand, s.Header_logo)} to="/">
            <img src={logoUrlSyr} alt="Oceanic" />
          </Link>
        );
      case 'spirotech':
        return (
          <Link className={cx(s.brand, s.Header_logo)} to="/">
            <img src={logoUrlSpirotech} alt="Spirotech" />
          </Link>
        );
      case 'vanmarcke':
        return null;
      default:
        return null;
    }
  };

  render() {
    const { pathname, authentication } = this.props;
    const userRole = authentication.get('userRole');
    const producent = authentication.get('producent');
    const ownershipCount = authentication.get('ownershipCount')
    return (
      <div className={s.root}>
        <div className={cx(s.container, s.root)}>
          <div className={cx(s.Header_inner, s.u_cf)}>
            <BasicNavigation
              userRole={userRole}
              producent={producent}
              ownershipCount={ownershipCount}
              pathname={pathname}
            />
            {this.getLogo(producent)}
          </div>
        </div>
      </div>
    );
  }
}

BasicHeader.propTypes = {
  getUserPriviliges: PropTypes.func.isRequired,
  authentication: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  pathname: PropTypes.string.isRequired,
};

const mapState = state => ({
  authentication: state.authentication,
});

const mapDispatch = dispatch => {
  return {
    getUserPriviliges: () => dispatch(getUserPriviliges()),
  };
};

export default compose(withStyles(s), connect(mapState, mapDispatch))(
  BasicHeader
);



// WEBPACK FOOTER //
// ./src/components/BasicHeader/Header.js